import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-sans font-bold uppercase tracking-widest transition-colors duration-300 min-h-[48px] px-8 py-3 rounded-sm text-sm';
  const variants = {
    primary: 'bg-brand-gold text-white hover:bg-brand-goldHover shadow-sm',
    outline: 'border border-brand-gold text-brand-gold hover:bg-brand-gold/5',
    ghost: 'text-brand-gold hover:bg-brand-gold/5'
  };
  const widthClass = fullWidth ? 'w-full' : 'w-full md:w-auto';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-184">
      {children}
    </button>;
}